/**
 * Settlement API
 * 정산 관련 API 호출 함수
 */

import { apiClient } from '../../../core/api/client';
import { SettlementRequest, SettlementResponse } from '../types/settlement';

const BASE_PATH = '/api/v1/mob/settlement';

/**
 * 정산 데이터 조회 API (라이더용)
 * @param params 정산 조회 요청 파라미터
 * @returns 정산 데이터 응답
 */
export const getSettlementData = async (params: SettlementRequest): Promise<SettlementResponse> => {
    const response = await apiClient.get<SettlementResponse>(
        `${BASE_PATH}/settlement-list`,
        { params }
    );
    return response.data;
};

/**
 * 협력사 정산 데이터 조회 API
 * @param fromDate 시작일 (YYYYMMDD)
 * @param toDate 종료일 (YYYYMMDD)
 * @returns 협력사 정산 데이터 응답
 */
export const getSupplierSettlementData = async (fromDate: string, toDate: string): Promise<SettlementResponse> => {
    const response = await apiClient.get<SettlementResponse>(
        '/api/v1/mob/supplier-settlement',
        { params: { fromDate, toDate } }
    );
    return response.data;
};
